import { el, setChildren, setAttr } from 'redom';

import { displayElementAroundAnchor } from 'utilities/element-position';

import './index.scss';

let currentVisibleFieldLabel = null;
let hideFieldLabelTimeout = null;

const HIDE_TIMEOUT_IN_MILLISECONDS = 100;

class FieldLabel {

  constructor(configuration) {

    this.text = configuration.text;
    this.tip = configuration.tip;
    this.tipAvailable = this.tip !== void 0;

    this.tooltipElement = null;
    this.el = el('label.field-label', {
      class: this.determineClasses(configuration),
      onmouseenter: this.handleMouseEnter.bind(this),
      onmouseleave: this.handleMouseLeave.bind(this)
    }, this.text);
  }

  determineClasses(configuration) {

    const classes = ['field-label'];

    if (typeof configuration.class === 'string') {
      classes.push(configuration.class);
    }

    if (configuration.fullText !== true) {
      classes.push('ellipsis');
    }

    return classes.join(' ').trim();

  }

  handleMouseEnter(event) {

    if (this.tipAvailable === false) {
      return;
    }

    if (currentVisibleFieldLabel && currentVisibleFieldLabel !== this) {
      currentVisibleFieldLabel.hideFieldLabel();
    }
    clearTimeout(hideFieldLabelTimeout);
    this.showFieldLabel();
    currentVisibleFieldLabel = this;
  }

  handleMouseLeave(event) {

    if (this.tipAvailable === false) {
      return;
    }

    hideFieldLabelTimeout = setTimeout(() => {
      this.hideFieldLabel();
    }, HIDE_TIMEOUT_IN_MILLISECONDS);
  }

  handleTooltipMouseEnter(event) {
    clearTimeout(hideFieldLabelTimeout);
  }

  handleTooltipMouseLeave(event) {
    hideFieldLabelTimeout = setTimeout(() => {
      this.hideFieldLabel();
    }, HIDE_TIMEOUT_IN_MILLISECONDS);
  }

  tryCreateTooltipContainer() {
    let tooltipContainer = document.getElementById('field-label-container');
    if (!tooltipContainer) {
      tooltipContainer = el('div#field-label-container');
      document.body.appendChild(tooltipContainer);
    }
    tooltipContainer.appendChild(this.tooltipElement);
    this.tooltipElement.style.display = 'none';
  }

  initializeTooltipStyle() {
    this.tooltipElement.style.transition = 'opacity 0.3s';
    this.tooltipElement.style.opacity = '0';
  }

  showFieldLabel() {
    this.tooltipElement.style.display = 'block';
    this.tooltipElement.style.opacity = '1';
    this.positionFieldLabel();
  }

  hideFieldLabel() {
    this.tooltipElement.style.opacity = '0';
    setTimeout(() => {
      this.tooltipElement.style.display = 'none';
    }, HIDE_TIMEOUT_IN_MILLISECONDS * 0.5); // Match the transition duration
  }

  positionFieldLabel() {

    const element = this.tooltipElement;
    const anchorElement = this.el;
    const viewportElement = undefined;
    const verticalOffset = 5;
    const horizontalOffset = 0;
    const startSide = 'top';
    const placeOnCenter = true;

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter);

  }

  initialize() {

    this.tooltipElement = el('div.field-label-tip', { onmouseenter: this.handleTooltipMouseEnter.bind(this), onmouseleave: this.handleTooltipMouseLeave.bind(this) }, this.tip);
    this.tryCreateTooltipContainer();
    this.initializeTooltipStyle();

  }

  onmount() {
    this.initialize();
  }

  onunmount() {
    this.tooltipElement?.parentNode?.removeChild(this.tooltipElement);
  }

  update(configuration) {

    this.text = configuration.text;
    this.tip = configuration.tip;
    this.tipAvailable = this.tip !== void 0;

    if (this.tipAvailable === false) {
      return;
    }

    setAttr(this.el, {
      class: this.determineClasses(configuration)
    });

    if (typeof this.tip === 'string') {
      this.tooltipElement.textContent = this.tip;
    } else {
      setChildren(this.tooltipElement, [this.tip]);
    }

  }

}

export default FieldLabel;